import React, { useState } from 'react';
import { Typography } from '@mui/material';

const CustomTooltip = ({ title, children, className, dataIndex }) => {
	const [visible, setVisible] = useState(false);

	return (
		<div
			style={{ position: 'relative', display: 'inline-block' }}
			onMouseEnter={() => setVisible(true)}
			onMouseLeave={() => setVisible(false)}
			className={className}
			data-index={dataIndex}>
			{children}
			{visible && (
				<div
					style={{
						position: 'absolute',
						top: '50%',
						left: '100%',
						transform: 'translateY(-50%)',
						marginLeft: '8px',
						backgroundColor: '#6d6d6d',
						color: '#fff',
						padding: '4px 8px',
						borderRadius: '4px',
						whiteSpace: 'nowrap',
						zIndex: 9999
					}}>
					<Typography fontSize={15}>{title}</Typography>
				</div>
			)}
		</div>
	);
};

export default CustomTooltip;
